"use client";

import type * as React from "react";
import { Skeleton } from "@/components/ui/skeleton";

/** Loading skeleton mirroring the Global Stats layout. */
export const GlobalStatsSkeleton: React.FC = () => (
  <div className="space-y-3" data-testid="global-stats-skeleton">
    <Skeleton variant="muted" className="h-14 w-full rounded-lg" />
    <div className="grid grid-cols-2 gap-2">
      <div className="space-y-2">
        <Skeleton variant="muted" className="h-16 w-full rounded-lg" />
        <Skeleton variant="muted" className="h-16 w-full rounded-lg" />
      </div>
      <Skeleton variant="muted" className="h-36 w-full rounded-lg" />
    </div>
    <Skeleton variant="muted" className="h-40 w-full rounded-lg" />
  </div>
);
